import React from "react";
import BackArrowButton from "../../../../parts/back-arrow-button";
import SettingsNav from "../../../../parts/settings-nav";
import submit from "submit-form";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";

export const CreateOrganizationComponent = ({ locals }) => {
  const {
    organizationRoles = [],
    organizationPermissions = [],
    activeUser,
  } = locals;

  const userIsPush = Boolean(activeUser.pushAccountInfo);
  const userIsPress = Boolean(activeUser.pressAccountInfo);

  //filtering the permissions to show if the user is push or press
  const filteredPermissions = organizationPermissions.filter(
    ({ permission }) => {
      if (
        (permission !== "PUSH" && permission !== "PRESS") ||
        (permission === "PUSH" && userIsPush) ||
        (permission === "PRESS" && userIsPress)
      ) {
        return true;
      }
      return false;
    }
  );

  /**
   * Function to convert the user to an organization
   * @param {*} e
   */
  const createOrganization = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const ownerRoleId = organizationRoles.find(
      ({ role }) => role === "Owner"
    )._id;

    const permissionIds = filteredPermissions.map(
      (permission) => permission._id
    );

    const body = {
      ownerRoleId,
      permissionIds,
    };

    if (
      process.browser &&
      confirm(
        "Are you sure you want to turn your account into an organization?"
      )
    ) {
      submit(`/actions/organizations/save`, {
        method: "POST",
        body,
      });
    }
  };

  return (
    <main className="settings create-organization">
      <SettingsNav classNames="mobile-hidden" />

      <section>
        <SettingsBackHandler title={"Manage Coaches"} />
        <h3 className="force-mobile-hidden">Manage Coaches</h3>
        <article>
          <div>
            <p className="s1">Turn your account into an organization</p>
            <p className="p4">
              As your business grows, you may have multiple Coaches or staff
              members working with you. Each coach can have their own login, and
              manage their own clients. Assign different roles to manage
              permissions (e.g. owner, admin, coach or nutritionist).
            </p>
          </div>
          <button data-button-type="primary" onClick={createOrganization}>
            Create Organization
          </button>
        </article>
      </section>
    </main>
  );
};
